import React, { useState, useEffect, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  // currencyFormat,
  /* formatDateTime, */ formatDateWithAMPM,
} from "../../../../common/Validations";
import { addInvoiceID } from "../../../../redux/feature/customer_app/preSalesSlice";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import {
  getCustomerV2Invoice,
  setEquipmentRentDocumentNumber,
} from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
// import { hasAccess } from "../../../../utils/roleUtils";
import ERFEwayBillConfirmationModal from "./ERFEwayBillConfirmationModal";
import CommonFilterCustomerV2 from "../../Customer_V2/Common/CommonFilterCustomerV2";

const ERFInvoiceListV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Order");
  localStorage.setItem("submenu", "Invoice");

  let invoiceListData = useSelector((state) => state?.customer?.invoice); // User Details from Store
  let invoiceListDataTable = useSelector(
    (state) => state?.customer?.invoice?.pagination,
  ); // User Details from Store

  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  let pageConfig = useSelector((state) => state?.common?.data?.pageConfig); // Config Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [data, setData] = useState([]);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [perPage, setPerPage] = useState(CustomerConstants.ROW_REPORT_PER_PAGE[0]);
  const [currentPage, setCurrentPage] = useState(1);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData, type) => {
    setItemLevelData(itemLevelData);
    if (type === "RE") {
      setItemLevelColumns(lineItemColInfo);
    } else if (type === "SL") {
      setItemLevelColumns(saleLineItemCol);
    } else if (type === "NA") {
      setItemLevelColumns(nursingItemsCol);
    }
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
// eslint-disable-next-line 
  const [userRole, setUserRole] = useState(null);
  // eslint-disable-next-line 
  const [pageConfigInfo, setPageConfigInfo] = useState(null);

  const [filterShow, setFilterShow] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const detailedPageInvoice = (invoiceNumber, manula) => {
    dispatch(addInvoiceID(invoiceNumber));
    if (manula) {
      navigate(Constants.CUSTOMER_V5_MR_ERF_INVOICE_DETAILS);
    } else {
      navigate(Constants.CUSTOMER_V5_MR_ERF_INVOICE_DETAILS);
    }
  };
  // eslint-disable-next-line 
  const detailedPage = (row) => {
    // Save document number to store/local before navigating
    dispatch(setEquipmentRentDocumentNumber(row.equipmentRentNr));
    navigate(CustomerConstants.CUSTOMER_V5_MR_ERF_DETAIL);
  };

  const [getModalEwayBill, setModalEwayBill] = useState(false);
  const [ewayBillData, setEwayBillData] = useState(null);

  const showEwayBill = (rowData) => {
    setModalEwayBill(true);
    setEwayBillData(rowData);
  };
  const hideEwayBillModal = () => {
    setModalEwayBill(false);
    setEwayBillData(null);
  };
  // Invoice Table Col
  const invoiceDataColumns = [
    {
      name: "Invoice Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {/* {formatDateTime(row.createdAt)} */}
            {formatDateWithAMPM(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row?.manualInvoice)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "ERF No",
    //   selector: (row) => row.equipmentRentNr, // MATCHED API KEY
    //   cell: (row) => (
    //     <button className="btnInfo" /* onClick={() => detailedPage(row)} */>
    //       {/* Fallback if documentNumber is missing */}
    //       {row.equipmentRentNr}
    //     </button>
    //   ),
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "ERF Type",
      selector: (row) => row.erfType,
      cell: (row) => (
        <div>
          <span>
            <TableStatusField status={row.erfType} />
          </span>
        </div>
      ),
      sortable: true,
      style: { justifyContent: "left" },
      width: "210px",
    },
    {
      name: "Rent Items",
      cell: (row) => (
        <>
          <span
            style={{
              marginLeft: "12px",
              cursor: row?.rentItems?.length > 0 ? "pointer" : "not-allowed",
              opacity: row?.rentItems?.length > 0 ? 1 : 0.5,
            }}
            onClick={() => {
              if (row?.rentItems?.length > 0) {
                lineItemShowModal(row.rentItems, "RE");
              }
            }}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>

          <span className="suppliersIcon">
            {row?.rentItems?.length > 0 ? row.rentItems.length : "--"}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Sale Items",
      cell: (row) => (
        <>
          <span
            style={{
              marginLeft: "12px",
              cursor: row?.saleItems?.length > 0 ? "pointer" : "not-allowed",
              opacity: row?.saleItems?.length > 0 ? 1 : 0.5,
            }}
            onClick={() => {
              if (row?.saleItems?.length > 0) {
                lineItemShowModal(row.saleItems, "SL");
              }
            }}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>

          <span className="suppliersIcon">
            {row?.saleItems?.length > 0 ? row.saleItems.length : "--"}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Nursing Items",
      cell: (row) => (
        <>
          <span
            style={{
              marginLeft: "12px",
              cursor: row?.nursingItems?.length > 0 ? "pointer" : "not-allowed",
              opacity: row?.nursingItems?.length > 0 ? 1 : 0.5,
            }}
            onClick={() => {
              if (row?.nursingItems?.length > 0) {
                lineItemShowModal(row.nursingItems, "NA");
              }
            }}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>

          <span className="suppliersIcon">
            {row?.nursingItems?.length > 0 ? row.nursingItems.length : "--"}
          </span>
        </>
      ),
      width: "120px",
    },

{
      name: "ERF For",
      selector: (row) => row.erfForType,
      cell: (row) => (
        <div className="d-flex flex-column">
        <p
          style={{
            color: row.erfForType === "Hospital" ? "red" : "green",
            fontWeight: "bold",
          }}
          className="p-0 m-0"
        >
          {row.erfForType}

        </p>
        <p className="p-0 m-0" >{row?.hospitalName || ""}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Patient Details",
      selector: (row) => row.patientName, // MATCHED API KEY
      cell: (row) => (
        <div className="py-2">
          < span className="fw-bold">{row.patientName.toUpperCase()}</span>
          <br/>
          < span>{row.contactNumber}</span>
          < span>{row.billingAddress}</span>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Amount",
      selector: (row) => row?.netAmount || 0,
      cell: (row) => (
        <div className="fw fw-bold">
          {`${Number(row?.netAmount || 0).toFixed(2)} INR`}
        </div>
      ),
      right: true,
      width: "130px",
    },
    {
      name: "Created By",
      selector: (row) => row.salePoint,
      cell: (row) => (
        <div>
          <span className="fw fw-bold">{row.createdBy}</span>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "Sale Point",
      selector: (row) => row.salePoint,
      cell: (row) => (
        <div>
          <span>{row.salePoint.toUpperCase()}</span>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "Hospital",
      selector: (row) => row.hospital,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.hospital || "--"}</p>
          <p className="p-0 m-0">{row.hospitalName || ""}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "Cost Center",
      selector: (row) => row.costCenter,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.costCenter || "--"}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "E_Way Bill Nr",
      selector: (row) => row.e_WayBillNo,
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.e_WayBillNo || "--"}</p>
        </div>
      ),
      wrap: true,
      width: "120px",
    },
    {
      name: "E-Way Bill Details",
      cell: (row) => (
        <>
          {row.e_WayBillNo ? (
            <div
              style={{ width: "100%" }}
              className="cursor-pointer d-flex justify-content-center"
            >
              <img
                src="assets/img/newIcons/delivery-truck.png"
                alt="attachments"
                style={{ width: "40px" }}
                className="mt-1"
                onClick={() => showEwayBill(row)}
              />
            </div>
          ) : (
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-center"
            >
              {" "}
              --{" "}
            </div>
          )}
        </>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  // Invoice Item Table Col
  const lineItemColInfo = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "From Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "To Date",
      selector: (row) => row?.toDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Rent Slab",
      selector: (row) => row?.rentSlab,
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];
  const saleLineItemCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.local_id} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];
  const nursingItemsCol = [
    {
      name: "SlNo.",
      cell: (row) => {
        const numberPart = row?.local_id?.split("-")[1];
        const slNo = numberPart !== undefined ? Number(numberPart) + 1 : "--";

        return (
          <div>
            <p className="m-0 p-0">{slNo}</p>
          </div>
        );
      },
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "getCustomerInvoiceList",
  //     page: page,
  //     per_page: getNewPerPage,
  //     rowFilter: Object.keys(activeFilters).length > 0 ? activeFilters : {},
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getCustomerV2Invoice(obj));
  // };

  // Common Search Function on button
 
 const fetchData = useCallback((page = 1, size = perPage, search = getCommonSearchTxt, filters = activeFilters) => {
  const obj = {
    queryName: "getCustomerInvoiceList",
    page,
    per_page: size,
    rowFilter: Object.keys(filters).length > 0 ? filters : {},
    searchTerm: search,
  };
  dispatch(getCustomerV2Invoice(obj));
}, [dispatch, perPage, getCommonSearchTxt, activeFilters]);

// ✅ Page change - uses current perPage state
const handlePageChange = (page) => {
  setCurrentPage(page);
  fetchData(page, perPage, getCommonSearchTxt, activeFilters);
};

// ✅ Per page change
const handlePerRowsChange = (newPerPage) => {
  setPerPage(newPerPage);
  setCurrentPage(1);
  fetchData(1, newPerPage, getCommonSearchTxt, activeFilters);
};

// ✅ Search - uses current perPage state (not hardcoded 10)
const handleSearchFuncApi = () => {
  setCurrentPage(1);
  fetchData(1, perPage, getCommonSearchTxt, activeFilters);
};
 
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "getCustomerInvoiceList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: Object.keys(activeFilters).length > 0 ? activeFilters : {},
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getCustomerV2Invoice(obj));
  // };

  // const handleFilterData = async (filters) => {
  //   setActiveFilters(filters);
  //   let obj = {
  //     queryName: "getCustomerInvoiceList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: Object.keys(filters).length > 0 ? filters : {},
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getCustomerV2Invoice(obj));
  // };
  const handleFilterData = (filters) => {
  setActiveFilters(filters);
  setCurrentPage(1);
  fetchData(1, perPage, getCommonSearchTxt, filters); // ← pass filters directly, not state
};


  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "getCustomerInvoiceList",
  //     page: page,
  //     per_page: newPerPage,
  //     rowFilter: Object.keys(activeFilters).length > 0 ? activeFilters : {},
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(getCustomerV2Invoice(obj));
  // };

  const loadInitialPOData = async () => {
    setData(invoiceListData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceListData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      rowFilter: Object.keys(activeFilters).length > 0 ? activeFilters : {},
    };
    dispatch(getCustomerV2Invoice(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const showEwayBill = (rowData) => {
  //   setModalEwayBill(true);
  //   setEwayBillData(rowData);
  // };
  // const hideEwayBillModal = () => {
  //   setModalEwayBill(false);
  //   setEwayBillData(null);
  // };
  // eslint-disable-next-line
  const navigateTomanualInvoice = () => {
    navigate(CustomerConstants.CUSTOMER_V2_MANUAL_INVOICE_CREATION);
  };

  useEffect(() => {
    const getRole = userData?.roles?.[0]?.roleId || null;
    setUserRole(getRole);
    setPageConfigInfo(pageConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig, userData]);

  // const handleAdvanceSearchFuncApi = async (filters) => {
  //   let obj = {
  //     queryName: "getCustomerInvoiceList",
  //     module: "CUSTOMER",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     rowFilter: {
  //       $and: [filters],
  //     },
  //   };
  //   dispatch(getCustomerV2Invoice(obj));
  // };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Invoice</h2>
                <p className="subText">Lists of Invoice and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={invoiceDataColumns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      handleFilterData(filters);
                      setFilterShow(!filterShow);
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IN</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Invoice List</span>
                      <span className="subHeaderTitle">
                        View of Invoice and Status{" "}
                      </span>
                    </Col>

                     <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      {/* {hasAccess(
                        userRole,
                        "buttons",
                        "customer_details_edit",
                        pageConfigInfo,
                      ) && (
                        <Col xs={6} md={6} lg={6}>
                          <button
                            className="btnTable"
                            onClick={navigateTomanualInvoice}
                          >
                            Manual Invoice
                          </button>
                        </Col>
                      )} */}
                      <Col xs={6} md={1} lg={1}>
                        <SourcingCommonFilter />
                      </Col>
                    </Col> 
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={invoiceDataColumns}
                          data={data}
                          progressPending={invoiceListData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_REPORT_PER_PAGE}
                          paginationPerPage={perPage}               
paginationDefaultPage={currentPage}
                          pagination
                          paginationServer
                          paginationTotalRows={invoiceListDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <ERFEwayBillConfirmationModal
        show={getModalEwayBill}
        onHide={() => hideEwayBillModal()}
        ewaybill={ewayBillData}
      />
    </main>
  );
};

export default ERFInvoiceListV2;
